import { render, staticRenderFns } from "./common-comments-display.vue?vue&type=template&id=74541add&"
import script from "./common-comments-display.vue?vue&type=script&lang=js&"
export * from "./common-comments-display.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports